import Modal from 'utils/packages/Modal';
import React, { useCallback } from 'react';
import { StyleSheet } from 'react-native';
import useRequiredBenefitCallback from 'features/premium/hooks/useRequiredBenefitCallback';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { useAddAccountModal } from 'features/accounts/hooks/useAddAccountModal';
import AddSpaceAccountModalContent from '../components/AddSpaceAccountModalContent';
export const useAddSpaceAccountModal = (spaceInfo, isDefault, onMoveAccountsComplete) => {
    const navigation = useMainStackNavigation();
    const onAddAccount = useAddAccountModal('Net worth', spaceInfo?.space.id);
    const onMoveAccounts = useRequiredBenefitCallback(useCallback(() => {
        if (isDefault) {
            navigation.navigateDeprecated('AllSpaceAccountsDraggable', {
                onMoveAccounts: onMoveAccountsComplete,
            });
        }
        else {
            if (!spaceInfo)
                return;
            navigation.navigateDeprecated('EditSpaceAccounts', {
                spaceInfo,
                onMoveAccounts: onMoveAccountsComplete,
            });
        }
    }, [isDefault, spaceInfo, onMoveAccountsComplete]), 'spaces');
    const show = useCallback(() => Modal.show(<AddSpaceAccountModalContent onAddAccount={onAddAccount} onMoveAccounts={onMoveAccounts}/>, {
        containerStyle: styles.modal,
        title: 'Add account',
        lightBg: true,
    }), [onAddAccount, onMoveAccounts]);
    return show;
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
});
